// Must evaluate before the router is created: it snapshots the raw QBO OAuth callback query.
import './modules/settings/accounting/quickbooks/initialQboCallbackSearch';
import { createRoot, hydrateRoot } from 'react-dom/client';

import App from './App';

const redwoodAppElement = document.getElementById('redwood-app');

if (redwoodAppElement.children?.length > 0) {
  hydrateRoot(redwoodAppElement, <App />);
} else {
  const root = createRoot(redwoodAppElement);
  root.render(<App />);
}
